import Vue from 'vue'
import Blog from './Blog.vue'
import store from './store'

Vue.config.productionTip = false;

new Vue({
    store,
    render: h => h(Blog),
}).$mount('#blog');
